import { IconButton, Stack, Tooltip } from '@mui/material';

import Iconify from 'src/components/iconify';
import { useTranslate } from 'src/locales';
import { CommunicationEntityRef } from 'src/services/integration/integrations.types';
import { useCommunicationActions } from './use-communication-actions';

// ----------------------------------------------------------------------

type Props = {
  phoneNumber?: string | null;
  name?: string;
  entity?: CommunicationEntityRef;
  size?: 'small' | 'medium';
};

/**
 * Click-to-call + SMS icon buttons for a candidate/contact phone number.
 * Renders nothing unless an active communications integration is connected and
 * a phone number is present.
 */
export default function CommunicationActions({ phoneNumber, name, entity, size = 'small' }: Props) {
  const { t } = useTranslate();
  const { commsActive, call, calling, openSms, smsModal } = useCommunicationActions(phoneNumber, name, entity);

  if (!commsActive) return null;

  return (
    <>
      <Stack direction="row" spacing={0.5}>
        <Tooltip title={t('integrations.communications.actions.call')}>
          <span>
            <IconButton size={size} onClick={call} disabled={calling}>
              <Iconify icon="solar:phone-bold" />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={t('integrations.communications.actions.sms')}>
          <IconButton size={size} onClick={openSms}>
            <Iconify icon="solar:chat-round-dots-bold" />
          </IconButton>
        </Tooltip>
      </Stack>

      {smsModal}
    </>
  );
}
